import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSignIn } from 'react-auth-kit';
import api from '../../../services/api';
import { API_URL } from '../../../config/apiUrl';
import logo from '../../../assets/logo.png';
import './styles.css';

const Login = () => {
  const [cpf, setCpf] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const signIn = useSignIn();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!cpf || !senha) {
        return;
      }

      const cpfLimpo = cpf.replace(/\D/g, '');

      const response = await api.post(API_URL.ADMIN_LOGIN.url, {
        cpf: cpfLimpo,
        senha,
        role: 'ADMIN'
      });

      if (response && response.data && response.data.access_token) {
        signIn({
          token: response.data.access_token,
          expiresIn: response.data.expiresIn,
          authState: response.data.usuario,
          tokenType: "Bearer",
        });
        
        navigate('/painel/gerenciar-cidades');
      }
    } catch (err) {
      console.error('Erro no login:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
            <img src={logo} alt="Logo" className="logo" />
          </div>
          <h1>Painel Administrativo</h1>
          <p>Faça login para gerenciar cidades</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="cpf">CPF</label>
            <input
              type="text"
              id="cpf"
              value={cpf}
              onChange={(e) => setCpf(e.target.value)}
              placeholder="Digite seu CPF"
              required
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="senha">Senha</label>
            <input
              type="password"
              id="senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              placeholder="Digite sua senha"
              required
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
